// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__DJDMv","active":"Modal_active__-p53x","content":"Modal_content__gGb69"};